import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ComponentService } from '../../../services/component.service';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { tap, filter, debounceTime } from 'rxjs/operators';

@Component({
	selector: 'app-whatsapp',
	templateUrl: './whatsapp.component.html',
	styleUrls: ['./whatsapp.component.scss']
})
export class WhatsappComponent implements OnInit, OnDestroy {
	@Input() componentData: any;
	@Input() formHeight: string;
	@Input() pageType: string;
	@Input() componentID: number;
	@Input() urlGlobalRegExp: any;
	@ViewChild('whatsappForm', { static: true }) whatsappForm: NgForm;
	@ViewChild('nameField', { static: true }) nameField;
	whatsappFormSubscription: Subscription;

	constructor(private comService: ComponentService) {}

	ngOnInit() {
		this.whatsappFormSubscription = this.whatsappForm.valueChanges
			.pipe(
				tap(() =>
					this.comService.updateDisabledSave(
						(this.whatsappForm.dirty && this.whatsappForm.invalid) || this.nameField.editComponentName
					)
				),
				filter((form) => this.whatsappForm.dirty && this.whatsappForm.valid),
				debounceTime(2000)
			)
			.subscribe();
	}

	ngOnDestroy() {
		this.whatsappFormSubscription.unsubscribe();
	}

	brodcastToPreview() {
		this.comService.updateComponentData(this.componentData);
		this.comService.updatePreviewData();
	}
}
